<template>
  <div>
    <section class="sub-banner01 banner-top02 position-relative float-start w-100">
      <TitAndBread></TitAndBread>
    </section>

    <main class="float-start w-100">
      <section class="whate-do d-inline-block w-100">
        <div class="container">
          <h6 class="text-center subt-text">我们可以做的</h6>
          <h2 class="text-center main-head-text text-white mt-3"> 一直努力，实现更多可能 </h2>
          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-5 mt-4">
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/9390927.png">
                </figure>
                <h5> 写作助手 </h5>
                <p> 生成想法、故事、诗歌或文章，满足各种写作需求，包括文案、创意写作等。可以帮助你产生富有想象力的文本，为你的创意项目提供灵感和素材。</p>
              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/6663539.png">
                </figure>
                <h5> AI 绘画 </h5>
                <p>创意与技术的完美融合，为艺术家和观众带来了更多的创作灵感和参与体验，为艺术创作注入了更多的创新可能性，展现出了艺术与技术完美融合的新面貌。
                </p>
              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/4298077.png">
                </figure>
                <h5> 星座运势 </h5>
                <p> 根据个人的出生日期、星座信息以及其他相关因素，为用户生成针对性的星座运势分析报告，帮助用户更好地了解自己的特点和发展方向。</p>
              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/1356321.png">
                </figure>
                <h5> 编程开发 </h5>
                <p> 为程序员带来了更多的辅助和智能化工具，提高了开发效率和代码质量，为编程开发注入了更多的创新和可能性，革新了代码创作的方式和未来发展方向。</p>

              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/4207282.png">
                </figure>
                <h5> 情感识别 </h5>
                <p> 可以识别文本中的情感色彩，包括正面、负面或中性情绪。它可以帮助你分析用户反馈、社交媒体内容或产品评论等，了解情感趋势并作出相应决策。</p>

              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/81460.png">
                </figure>
                <h5> 学术论文 </h5>
                <p> 学术论文写作过程中一个重要辅助工具，帮助解决各种问题，提高论文质量；帮助收集相关文献并生成文献综述，快速了解所选课题领域的较新研究进展。</p>

              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/1792412.png">
                </figure>
                <h5> 数据分析</h5>
                <p> 在数据分析方面的使用可以帮助企业更深入地理解和利用其数据，提高数据分析的效率和准确性，为企业决策和业务运营提供更科学、更可靠的支持。</p>

              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/9008924.png">
                </figure>
                <h5> 营销文案</h5>
                <p>营销文案进行情感分析，基于情感分析的结果，营销团队可以调整文案内容，以更好地触动用户情感，增加品牌认可度和用户黏性。
                </p>

              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/11186814.png">
                </figure>
                <h5> 短视频创作</h5>
                <p> AI在生成短视频方面的使用可以提高视频内容的创作效率和质量，实现个性化推荐和用户参与，帮助用户和营销团队更好地实现视频营销和内容创作目标。</p>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="d-inline-block getst-work-home-06 w-100">
        <div class="container position-relative">
          <FooterHint></FooterHint>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
import TitAndBread from '@/components/TitAndBread';
import FooterHint from '@/components/FooterHint';
export default {
  name: '',
  components: { TitAndBread, FooterHint },
  props: {},
  data() {
    return {
    }
  },
  methods: {}
}
</script>

<style scoped lang="less"></style>
